module.exports = __webpack_public_path__ + "img/HrmCompany.7ecafe03.svg";